import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { FormControl } from "@mui/material";
import { normalizeCurrency } from "core/utils/normalizeCurrency.ts";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import Select from "react-select";
import IAHelpButton from "../../../../../components/IaHelpButton/IaHelpButton.tsx";
import NewIcon from "../../../../../components/NewIcon/NewIcon";
import SelectEmbarqueV2 from "../../../../../components/SelectEmbarqueV2/SelectEmbarqueV2";
import { useToast } from "../../../../../contexts/ToastContext.tsx";
import Separator from "../../../../../core/components/Separator.tsx";
import SelectInputField from "../../../../../core/data-entry/SelectInputField.tsx";
import { valorMask } from "../../../../../regex/valorMask";
import CadastroViagemSectionTitle from "../../components/CadastroViagemSectionTitle.tsx";

function FormEmbarqueTop({
	pedidoValido,
	pedidoOptions,
	setOpenCadastroPedido,
	calcularIcms,
	setIdAtual,
	setDisable,
	taxaIcms,
	contextoEmbarque,
	clienteOptions,
	destinatarioValido,
	setOpenCadastroCliente,
	setValues,
	values,
	empresaValido,
	setEmpresaValido,
	empresaSub,
	setSimplesNacional,
	setValuesSelect,
	setValidator,
	setOpenCadastroEmpresa,
	valuesSelect,
	openInformacao,
	setOpenInformacao,
	setOpenCadastroFilial,
	filial,
	estiloFrota,
	labelFrota,
	selectMessage,
	setOpenCadastroStatus,
	disabledFreteFiscal,
	previsaoEmbarqueValido,
	previsaoEmbarqueRange,
	setPrevisaoEmbarqueValido,
	setPrevisaoEmbarqueRange,
	dataHoraChegadaEmbarqueRange,
	setDataHoraChegadaEmbarqueRange,
	dataHoraEmbarcadoRange,
	setDataHoraEmbarcadoRange,
	previsaoEntregaValido,
	previsaoEntregaRange,
	setPrevisaoEntregaRange,
	setPrevisaoEntregaValido,
	isCadastro,
	dataHoraChegadaEntregaRange,
	setDataHoraChegadaEntregaRange,
	dataHoraEntregueRange,
	setDataHoraEntregueRange,
	veiculoOptions,
	setOpenCadastroVeiculo,
	mostrarInput,
	props,
	abrirWhats,
	calcular,
	opcoesFrota,
	status,
	setVeiculoOptions,
	setPedidoValido,
	setPedidoOptions,
	defaultPedidoOptions,
	params,
	simplesNacional,
	setIcmsEmbutido,
	buscarTaxaIcms,
	opcoesPedido,
	setDisabledFreteFiscal,
	setClienteOptions,
	clientes,
	pedido,
	setMostrarInput,
	defaultVeiculoOptions,
	veiculo,
	setOpenModalEncontrarVeiculo,
	handleEmpresaChange,
}) {
	const [verificaMotorista2, setVerificaMotorista2] = useState(false);
	const [listaMotoristas, setListaMotoristas] = useState();
	const [listaMotoristas2, setListaMotoristas2] = useState();
	const [idMotoristas, setIdMotoristas] = useState();
	const [idMotoristas2, setIdMotoristas2] = useState();

	const { showToast } = useToast();

	useEffect(() => {
		if (isCadastro) return;
		if (!values) return;

		const veiculo = values.veiculo;

		if (!veiculo && !values.veiculoMotorista) return;

		const motoristaPrincipal = veiculo?.veiculoMotorista || null;
		const motoristaSecundario = veiculo?.veiculoMotorista2 || null;

		if (!motoristaPrincipal && !motoristaSecundario) return;

		const principalId = motoristaPrincipal
			? (motoristaPrincipal.idMotorista ?? motoristaPrincipal.id)
			: null;

		const secundarioId = motoristaSecundario
			? (motoristaSecundario.idMotorista ?? motoristaSecundario.id)
			: null;

		setListaMotoristas(motoristaPrincipal?.nome ?? null);
		setIdMotoristas(principalId);

		if (motoristaSecundario) {
			setVerificaMotorista2(false);
			setListaMotoristas2(motoristaSecundario.nome);
			setIdMotoristas2(secundarioId);
		} else {
			setVerificaMotorista2(true);
			setListaMotoristas2(null);
			setIdMotoristas2(null);
		}

		if (!values.motoristaSelecionadoId) {
			const motoristaSelecionado =
				values.veiculoMotorista || motoristaPrincipal;
			if (!motoristaSelecionado) return;

			const selecionadoId =
				motoristaSelecionado.idMotorista ?? motoristaSelecionado.id;

			setValues((current) => ({
				...current,
				motorista: motoristaSelecionado.nome,
				motoristaSelecionadoId: selecionadoId,
			}));
		}
	}, [isCadastro, values, setValues]);

	const handleVeiculoInputChange = useCallback(
		(inputValue) => {
			const normalizedInput = inputValue.target.value.trim().toLowerCase();

			if (normalizedInput === "") {
				setVeiculoOptions([]);
				return;
			}

			const filteredOptions = veiculo
				.filter((veiculo) => {
					const placa = veiculo.caminhao?.placa?.toLowerCase() || "";
					const proprietario =
						veiculo.proprietarioVeiculo?.nome?.toLowerCase() || "";

					return (
						placa.includes(normalizedInput) ||
						proprietario.includes(normalizedInput)
					);
				})
				.map((data) => ({
					title: `${data.caminhao?.placa || ""} - ${
						data.proprietarioVeiculo?.nome ?? ""
					}`,
					obj: data,
				}))
				.sort((a, b) => a.title.localeCompare(b.title));

			setVeiculoOptions(filteredOptions);
		},
		[veiculo, setVeiculoOptions]
	);

	const handlePlacaCavaloChange = useCallback(
		(option) => {
			const selectedOption = option.obj;
			setMostrarInput(selectedOption?.caminhao?.frota);
			setVeiculoOptions(defaultVeiculoOptions);
			setValues((current) => ({
				...current,
				veiculoId: selectedOption.idVeiculo,
				placaCavalo: selectedOption.caminhao?.placa,
				placaCarreta: selectedOption.carreta?.placa,
				placaCarreta2: selectedOption.carreta2?.placa,
				proprietario: selectedOption.proprietarioVeiculo?.nome,
				motorista: selectedOption.veiculoMotorista.nome,
				motoristaSelecionadoId: selectedOption.veiculoMotorista.idMotorista,
			}));
			setValuesSelect((current) => ({
				...current,
				placaCavalo: option,
			}));
			setValidator((current) => ({
				...current,
				validatorPlacaCavalo: "true",
				validatorPlacaCarreta: "true",
				validatorPlacaCarreta2: "true",
				validatorProprietario: "true",
				validatorMotorista: "true",
			}));

			if (selectedOption?.caminhao?.frota) {
				setValidator((current) => ({
					...current,
					validatorPrevisaoEmbarque: "true",
					validatorEmpresa: "true",
				}));
				setPrevisaoEmbarqueValido(true);
				setEmpresaValido(true);
			} else {
				setValidator((current) => ({
					...current,
					validatorPrevisaoEmbarque: values.previsaoEmbarque ? "true" : "false",
					validatorEmpresa: values.empresaId ? "true" : "false",
				}));
				setPrevisaoEmbarqueValido(!!values.previsaoEmbarque);
				setEmpresaValido(!!values.empresaId);
			}

			if (selectedOption.veiculoMotorista2) {
				setVerificaMotorista2(false);
				setListaMotoristas(selectedOption.veiculoMotorista?.nome || "");
				setListaMotoristas2(selectedOption.veiculoMotorista2?.nome || "");
				setIdMotoristas(selectedOption.motoristaId);
				setIdMotoristas2(selectedOption.motorista2Id);
			} else {
				setVerificaMotorista2(true);
				setListaMotoristas(selectedOption.veiculoMotorista);
				setValues((current) => ({
					...current,
					motorista: selectedOption.veiculoMotorista.nome,
				}));
			}
			if (selectedOption.veiculoMotorista?.bloqueado) {
				showToast(
					`O motorista selecionado está bloqueado pelo motivo: ${selectedOption.veiculoMotorista.motivo}`,
					"warning"
				);
			}
		},
		[
			values,
			setValues,
			setValuesSelect,
			setValidator,
			setPrevisaoEmbarqueValido,
			setEmpresaValido,
			setVeiculoOptions,
			setMostrarInput,
			setListaMotoristas,
			setListaMotoristas2,
			setIdMotoristas,
			setIdMotoristas2,
			showToast,
			defaultVeiculoOptions,
		]
	);

	const handlePedidoInputChange = useCallback(
		(inputValue) => {
			const normalizedInput = inputValue.target.value.trim().toLowerCase();

			if (normalizedInput === "") {
				setPedidoOptions([]);
				return;
			}

			const filteredOptions = pedido
				.filter((pedido) => {
					const tipoRota = pedido.tipoRota?.toLowerCase() || "";
					const cidadeDestino =
						pedido.rota?.cidadeDestinoRota.cidade?.toLowerCase() || "";
					const cidadeOrigem =
						pedido.rota?.cidadeOrigemRota.cidade?.toLowerCase() || "";
					const pedidoNumero = pedido.pedido?.toString() || "";

					return (
						tipoRota.includes(normalizedInput) ||
						cidadeDestino.includes(normalizedInput) ||
						cidadeOrigem.includes(normalizedInput) ||
						pedidoNumero.includes(normalizedInput)
					);
				})
				.sort((a, b) => a.pedido - b.pedido)
				.slice(0, 100)
				.map((data) => ({
					title: `${data.pedido} - ${data.tipoRota} @ ${data.rota.cidadeDestinoRota.cidade} - ${data.rota.cidadeDestinoRota.abreviacao} - ${data.rota.cidadeOrigemRota.cidade} - ${data.rota.cidadeOrigemRota.abreviacao}`,
					obj: data,
				}));

			const uniqueOptions = Array.from(
				new Map(filteredOptions.map((item) => [item.title, item])).values()
			);

			setPedidoOptions(uniqueOptions);
		},
		[pedido, setPedidoOptions]
	);

	const handleClienteInputChange = useCallback(
		(inputValue) => {
			const normalizedInput = inputValue.target.value.trim().toLowerCase();

			if (normalizedInput === "") {
				setClienteOptions([]);
				return;
			}

			const filteredOptions = clientes
				.filter((cliente) => {
					const nomeFantasia = cliente.nomeFantasia?.toLowerCase() || "";
					const cnpj = cliente.cnpj?.replace(/\D/g, "").toLowerCase() || "";
					const apelido = cliente.apelido?.toLowerCase() || "";

					return (
						nomeFantasia.includes(normalizedInput) ||
						cnpj.includes(normalizedInput) ||
						apelido.includes(normalizedInput)
					);
				})
				.sort((a, b) => a.nomeFantasia.localeCompare(b.nomeFantasia))
				.slice(0, 100)
				.map((cliente) => ({
					title: cliente.nomeFantasia,
					obj: cliente,
				}));

			setClienteOptions(filteredOptions);
		},
		[clientes, setClienteOptions]
	);

	const handleStatusChange = useCallback(
		(e) => {
			const selectedStatus = status.find((option) => option.nome === e.value);
			setValuesSelect((current) => ({
				...current,
				status: e,
			}));
			setValues((current) => ({
				...current,
				status: e.value,
				statusId: selectedStatus.idStatus,
			}));
			setValidator((current) => ({
				...current,
				validatorStatus: "true",
			}));
		},
		[setValues, setValuesSelect, setValidator, status]
	);

	const handlePedidoChange = (option) => {
		const selectedOption = option.obj;
		setPedidoValido(true);
		if (selectedOption) {
			setPedidoOptions(defaultPedidoOptions);
			setValues((current) => ({
				...current,
				pedidoId: selectedOption.idPedido,
				pedido: selectedOption.pedido,
				cliente: selectedOption.cliente,
				destinatario: selectedOption.destinatario,
				embarcador: selectedOption.embarcador,
				km: selectedOption.km,
				freteFiscal: selectedOption.freteFiscal,
				pedagio: selectedOption.pedagio,
				classificacao: selectedOption.classificacao,
				freteMotorista: selectedOption.freteMotorista,
				valorEmbarqueId: selectedOption.valorEmbarqueId,
			}));
			setValues((current) => ({ ...current, icms: selectedOption?.icms }));
			if (
				(params?.origem === "origem" && params?.contexto === "frota") ||
				simplesNacional
			) {
				setValues((current) => ({ ...current, icms: "0,00" }));
			}

			if (contextoEmbarque !== "frota") {
				setIcmsEmbutido(selectedOption?.icmsEmbutido);
				buscarTaxaIcms(
					selectedOption.embarcadorEstado,
					selectedOption.destinatarioEstado
				);
			}
			const pedidoSelecionado = opcoesPedido.find(
				(option) => option.pedido === selectedOption.pedido
			);

			setDisabledFreteFiscal(!pedidoSelecionado.permiteAlterarFreteFiscal);
			setValuesSelect((current) => ({
				...current,
				pedido: option,
				destinatario: {
					title: `${option.obj.destinatarioPedido.nomeFantasia} | ${
						option.obj.destinatarioPedido.apelido
							? option.obj.destinatarioPedido.apelido
							: "Favor, cadastrar apelido de Cliente"
					}`,
					obj: option.obj.destinatarioPedido,
				},
			}));
			setValidator((current) => ({
				...current,
				validatorPedido: "true",
				validatorDestinatario: "true",
				validatorIcms: "true",
				validatorEmbarcador: "true",
				validatorFreteFiscal: "true",
			}));
			setPedidoValido(true);
		}
	};

	const clearPlacaCavalo = () => {
		setVeiculoOptions([]);
		setValues((current) => ({
			...current,
			veiculoId: null,
			placaCavalo: "",
			placaCarreta: "",
			placaCarreta2: "",
			proprietario: "",
			KmVazio: null,
			motorista: "",
			motoristaSelecionadoId: null,
		}));
		setValuesSelect((current) => ({ ...current, placaCavalo: "" }));
		setValidator((current) => ({
			...current,
			validatorPlacaCavalo: "false",
			validatorPlacaCarreta: "false",
			validatorPlacaCarreta2: "false",
			validatorProprietario: "false",
			validatorMotorista: "false",
		}));
	};

	const clearPedido = () => {
		setValues((current) => ({
			...current,
			pedidoId: null,
			pedido: "",
			cliente: "",
			destinatario: "",
			embarcador: "",
			km: "",
			freteFiscal: "",
			valorEmbarqueId: null,
			icms: "0,00",
			classificacao: "",
			freteMotorista: "",
			pedagio: "",
		}));
		setValuesSelect((current) => ({ ...current, pedido: "" }));
		setValidator((current) => ({
			...current,
			validatorPedido: "false",
			validatorDestinatario: "false",
			validatorIcms: "false",
			validatorEmbarcador: "false",
			validatorFreteFiscal: "false",
		}));
		setValuesSelect((current) => ({ ...current, destinatario: "" }));
		setPedidoValido(false);
		setPedidoOptions(defaultPedidoOptions);
	};

	const clearStatus = () => {
		setValuesSelect((current) => ({ ...current, status: "" }));
		setValues((current) => ({ ...current, status: "" }));
		setValues((current) => ({ ...current, statusId: null }));
		setValidator((current) => ({ ...current, validatorStatus: "false" }));
	};

	const clearFilial = () => {
		setValuesSelect((current) => ({ ...current, filial: "" }));
		setValues((current) => ({ ...current, filial: "", filialId: null }));
		setValidator((current) => ({ ...current, validatorFilial: "false" }));
	};

	const clearEmpresa = () => {
		setValuesSelect((current) => ({ ...current, empresa: "" }));
		setValues((current) => ({ ...current, empresa: "", empresaId: null }));
		setValidator((current) => ({ ...current, validatorEmpresa: "false" }));
		setEmpresaValido(false);
	};

	const clearDestinatario = () => {
		setValuesSelect((current) => ({ ...current, destinatario: "" }));
		setValues((current) => ({ ...current, destinatario: "" }));
		setValues((current) => ({ ...current, destinatarioId: null }));
		setValidator((current) => ({ ...current, validatorDestinatario: "false" }));
		setValuesSelect((current) => ({ ...current, destinatarioLabel: "" }));
	};

	const disabledIaButtonToolTip = useMemo(() => {
		if (!values.pedidoId) {
			return "Selecione um pedido!";
		}
		if (!values.previsaoEmbarque) {
			return "Defina a previsão de embarque!";
		}
		return "";
	}, [values.pedidoId, values.previsaoEmbarque]);

	const disabledIaButton = useMemo(() => {
		return !values.pedidoId || !values.previsaoEmbarque;
	}, [values.pedidoId, values.previsaoEmbarque]);

	return (
		<>
			<CadastroViagemSectionTitle title="Dados de Viagem:" />
			<div className="container-select-emb">
				<div className="coluna-1-emb">
					<div className={empresaValido ? "coluna-emb" : "coluna-emb-erro"}>
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Empresa:
							</p>
							<SelectEmbarqueV2
								classeCss={200}
								onChange={handleEmpresaChange}
								onClick={(e) => {
									e.stopPropagation();
									setDisable(true);
									setOpenCadastroEmpresa(true);
								}}
								clearSelection={clearEmpresa}
								onInfoIconClick={setIdAtual}
								id="idEmpresaSub"
								pequeno={true}
								value={valuesSelect.empresa}
								titulo="Empresa"
								dadosSelect={empresaSub}
								referenciaId="nome"
								referenciaItem="nome"
								erro={!empresaValido}
								open={openInformacao}
								onClose={() => {
									setOpenInformacao(false);
								}}
							/>
							{!empresaValido && <div className="error-text">Obrigatório!</div>}
						</div>
						<NewIcon
							onClick={() => {
								setOpenCadastroEmpresa(true);
								setIdAtual(null);
								setDisable(false);
							}}
						/>
					</div>
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Filial:
							</p>
							<SelectEmbarqueV2
								classeCss={200}
								onChange={(e) => {
									setValuesSelect((current) => ({
										...current,
										filial: e,
									}));
									setValues((current) => ({
										...current,
										filial: e.value,
									}));
									setValues((current) => ({
										...current,
										filialId: e.id,
									}));
									setValidator((current) => ({
										...current,
										validatorFilial: "true",
									}));
								}}
								onClick={(e) => {
									e.stopPropagation();
									setDisable(true);
									setOpenCadastroFilial(true);
								}}
								clearSelection={clearFilial}
								onInfoIconClick={setIdAtual}
								pequeno={true}
								id="idFilial"
								value={valuesSelect.filial}
								titulo="Filial"
								dadosSelect={filial}
								referenciaId="nome"
								referenciaItem="nome"
							/>
						</div>
						<NewIcon
							onClick={() => {
								setOpenCadastroFilial(true);
								setIdAtual(null);
								setDisable(false);
							}}
						/>
					</div>
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Peso:
							</p>
							<input
								type="text"
								className="input-emb"
								style={{ width: "172px" }}
								onChange={(e) => {
									setValues((current) => ({
										...current,
										peso: e.target.value,
									}));
								}}
								placeholder="0,00"
								value={valorMask(values.peso) || "0,00"}
							/>
						</div>
					</div>
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Cte:
							</p>
							<input
								maxLength="5"
								placeholder="00000"
								type="text"
								className="input-emb"
								style={{ width: "172px" }}
								onChange={(e) => {
									let valor = e.target.value;
									valor = valor.replace(/\D/g, "");
									setValues((current) => ({ ...current, cte: valor }));
								}}
								value={valorMask(values.cte)}
							/>
						</div>
					</div>
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Status:
							</p>
							<FormControl sx={{ width: 180 }}>
								<Select
									value={valuesSelect.status}
									options={status.map((data) => ({
										value: data.nome,
										label: data.nome,
									}))}
									styles={estiloFrota}
									label={labelFrota}
									clearSelection={clearStatus}
									placeholder="Digite para buscar."
									noOptionsMessage={({ inputValue }) =>
										selectMessage(inputValue)
									}
									onChange={(selectedOption) =>
										handleStatusChange(selectedOption)
									}
								/>
							</FormControl>
						</div>
						<NewIcon
							onClick={() => {
								setOpenCadastroStatus(true);
								setIdAtual(null);
								setDisable(false);
							}}
						/>
					</div>
				</div>
				<Separator size="xl" />
				<div className="coluna-2-emb">
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Observação:
							</p>
							<input
								type="text"
								className="input-emb"
								style={{ width: "400px" }}
								onChange={(e) => {
									setValues((current) => ({
										...current,
										observacao: e.target.value,
									}));
								}}
								value={values.observacao || ""}
							/>
						</div>
					</div>
				</div>
			</div>
			<Separator size="lg" />
			<div className="container-select-emb">
				<div className="coluna-1-emb">
					<div className={pedidoValido ? "coluna-emb" : "coluna-emb-erro"}>
						<SelectInputField
							label="Pedido"
							placeholder="Digite para buscar."
							disabled={false}
							options={pedidoOptions}
							value={valuesSelect.pedido?.title || ""}
							onInputChange={handlePedidoInputChange}
							onChange={handlePedidoChange}
							error={!pedidoValido}
							clearIcon={true}
							onClear={clearPedido}
						/>
						<NewIcon
							onClick={() => {
								setOpenCadastroPedido(true);
								setIdAtual(null);
								setDisable(false);
							}}
						/>
					</div>
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Classificação:
							</p>
							<input
								type="text"
								className="input-emb"
								placeholder="0,00"
								style={{ width: "152px" }}
								onChange={(e) => {
									setValues((current) => ({
										...current,
										classificacao: e.target.value,
									}));
								}}
								onBlur={(e) => {
									setValues((current) => ({
										...current,
										classificacao: normalizeCurrency(
											e.target.value
										),
									}));
								}}
								value={values.classificacao}
								disabled={false}
							/>
						</div>
					</div>
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Cliente:
							</p>
							<input
								type="text"
								className="input-emb"
								style={{ width: "152px" }}
								onChange={(e) => {
									setValues((current) => ({
										...current,
										cliente: e.target.value,
									}));
								}}
								value={values.cliente || ""}
								disabled={true}
							/>
						</div>
					</div>
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Embarcador:
							</p>
							<input
								type="text"
								className="input-emb"
								style={{ width: "152px" }}
								onChange={(e) => {
									setValues((current) => ({
										...current,
										embarcador: e.target.value,
									}));
									setValidator((current) => ({
										...current,
										validatorEmbarcador: "true",
									}));
								}}
								value={values.embarcador || ""}
								disabled={true}
							/>
						</div>
					</div>
					<div className="coluna-emb">
						<SelectInputField
							label="Destinatário"
							options={clienteOptions}
							value={valuesSelect.destinatario?.title || ""}
							onInputChange={handleClienteInputChange}
							onClear={clearDestinatario}
							onChange={(selectedOption) => {
								if (selectedOption.obj.apelido === null) {
									setValues((current) => ({
										...current,
										destinatario: selectedOption.obj.nomeFantasia,
									}));
								} else {
									setValues((current) => ({
										...current,
										destinatario: selectedOption.obj.apelido,
									}));
								}
								setValues((current) => ({
									...current,
									destinatarioId: selectedOption.obj.idCliente,
								}));
								setValuesSelect((current) => ({
									...current,
									destinatario: selectedOption,
								}));
								setValidator((current) => ({
									...current,
									validatorDestinatario: "true",
								}));
							}}
							error={!destinatarioValido}
						/>
						<NewIcon
							onClick={() => {
								setOpenCadastroCliente(true);
								setIdAtual(null);
								setDisable(false);
							}}
						/>
					</div>
				</div>
				<Separator size="xl" />
				<div className="coluna-2-emb">
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Km:
							</p>
							<input
								type="text"
								className="input-emb"
								style={{ width: "152px" }}
								onChange={(e) => {
									setValues((current) => ({
										...current,
										km: e.target.value,
									}));
								}}
								value={values.km || ""}
								disabled={true}
							/>
						</div>
					</div>
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Frete Motorista:
							</p>
							<input
								type="text"
								className="input-emb"
								style={{ width: "126.5px" }}
								onChange={(e) => {
									setValues((current) => ({
										...current,
										freteMotorista: e.target.value,
									}));
								}}
								onBlur={(e) => {
									setValues((current) => ({
										...current,
										freteMotorista: normalizeCurrency(
											e.target.value
										),
									}));
								}}
								value={values.freteMotorista}
							/>
						</div>
					</div>
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Pedágio:
							</p>
							<input
								type="text"
								className="input-emb"
								style={{ width: "126.5px" }}
								onChange={(e) => {
									setValues((current) => ({
										...current,
										pedagio: e.target.value,
									}));
								}}
								onBlur={(e) => {
									setValues((current) => ({
										...current,
										pedagio: normalizeCurrency(e.target.value, "0,00", true),
									}));
								}}
								value={values.pedagio}
							/>
						</div>
					</div>
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Frete Fiscal:
							</p>
							<input
								type="text"
								className="input-emb"
								style={{ width: "126.5px" }}
								onChange={(e) => {
									setValues((current) => ({
										...current,
										freteFiscal: e.target.value,
									}));
									setValidator((current) => ({
										...current,
										validatorFreteFiscal: "true",
									}));
									calcularIcms({
										freteFiscal: e.target.value === "" ? 0 : e.target.value,
									});
								}}
								value={values.freteFiscal || ""}
								disabled={disabledFreteFiscal}
								onBlur={(e)=>{
									setValues((current)=>({
										...current,
										freteFiscal: normalizeCurrency(e.target.value),
									}))
								}}
							/>
						</div>
					</div>
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								ICMS:
							</p>
							<input
								type="text"
								className="input-emb"
								style={{ width: "126.5px" }}
								onChange={() => {}}
								value={values?.icms || ""}
								disabled
							/>
						</div>
					</div>
				</div>
			</div>

			<CadastroViagemSectionTitle title="Datas:" />
			<div className="container-select-emb">
				<div className="coluna-1-emb">
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Previsão de Embarque:
							</p>
							<input
								type="datetime-local"
								className={
									previsaoEmbarqueValido && previsaoEmbarqueRange
										? "input-emb"
										: "input-emb-erro"
								}
								style={{ width: "208px" }}
								onChange={(e) => {
									if (e.target.value) {
										setValues((current) => ({
											...current,
											previsaoEmbarque: e.target.value,
										}));
										setPrevisaoEmbarqueValido(true);
										setPrevisaoEmbarqueRange(true);
										setValidator((current) => ({
											...current,
											validatorPrevisaoEmbarque: "true",
										}));
									} else {
										setValues((current) => ({
											...current,
											previsaoEmbarque: e.target.value,
										}));
										if (contextoEmbarque !== "templateEmbarque") {
											setPrevisaoEmbarqueValido(false);
											setValidator((current) => ({
												...current,
												validatorPrevisaoEmbarque: "false",
											}));
										}
									}
								}}
								value={values.previsaoEmbarque || ""}
							/>
							{!previsaoEmbarqueValido && (
								<div className="error-text">Obrigatório!</div>
							)}
							{!previsaoEmbarqueRange && previsaoEmbarqueValido && (
								<div className="error-text">Data inválida!</div>
							)}
						</div>
					</div>
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Dt.hr Chegada Embarque:
							</p>
							<input
								type="datetime-local"
								className={
									dataHoraChegadaEmbarqueRange ? "input-emb" : "input-emb-erro"
								}
								style={{ width: "208px" }}
								onChange={(e) => {
									setDataHoraChegadaEmbarqueRange(true);
									setValues((current) => ({
										...current,
										dataHoraChegadaEmbarque: e.target.value,
									}));
								}}
								value={values.dataHoraChegadaEmbarque || ""}
							/>
							{!dataHoraChegadaEmbarqueRange && (
								<div className="error-text">Data inválida!</div>
							)}
						</div>
					</div>
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Dt.hr Embarcado:
							</p>
							<input
								type="datetime-local"
								className={
									dataHoraEmbarcadoRange ? "input-emb" : "input-emb-erro"
								}
								style={{ width: "208px" }}
								onChange={(e) => {
									setDataHoraEmbarcadoRange(true);
									setValues((current) => ({
										...current,
										dataHoraEmbarcado: e.target.value,
									}));
								}}
								value={values.dataHoraEmbarcado || ""}
							/>
							{!dataHoraEmbarcadoRange && (
								<div className="error-text">Data inválida!</div>
							)}
						</div>
					</div>
				</div>
				<Separator size="lg" />
				<div className="coluna-2-emb">
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Previsão de Entrega:
							</p>
							<input
								type="datetime-local"
								className={
									previsaoEntregaValido && previsaoEntregaRange
										? "input-emb"
										: "input-emb-erro"
								}
								style={{ width: "208px" }}
								onChange={(e) => {
									if (e.target.value) {
										setValues((current) => ({
											...current,
											previsaoEntrega: e.target.value,
										}));
										setPrevisaoEntregaRange(true);
										setPrevisaoEntregaValido(true);
										setValidator((current) => ({
											...current,
											validatorPrevisaoEntrega: "true",
										}));
									} else {
										setValues((current) => ({
											...current,
											previsaoEntrega: "",
										}));
										if (
											contextoEmbarque !== "templateEmbarque" &&
											!isCadastro
										) {
											setPrevisaoEntregaValido(false);
											setValidator((current) => ({
												...current,
												validatorPrevisaoEntrega: "false",
											}));
										}
									}
								}}
								value={values.previsaoEntrega || ""}
							/>
							{!previsaoEntregaValido && (
								<div className="error-text">Obrigatório!</div>
							)}
							{!previsaoEntregaRange && previsaoEntregaValido && (
								<div className="error-text">Data inválida!</div>
							)}
						</div>
					</div>
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Dt.hr Chegada Entrega:
							</p>
							<input
								type="datetime-local"
								className={
									dataHoraChegadaEntregaRange ? "input-emb" : "input-emb-erro"
								}
								style={{ width: "208px" }}
								onChange={(e) => {
									setDataHoraChegadaEntregaRange(true);
									setValues((current) => ({
										...current,
										dataHoraChegadaEntrega: e.target.value,
									}));
								}}
								value={values.dataHoraChegadaEntrega || ""}
							/>
							{!dataHoraChegadaEntregaRange && (
								<div className="error-text">Data inválida!</div>
							)}
						</div>
					</div>
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Dt.hr Entregue:
							</p>
							<input
								type="datetime-local"
								className={
									dataHoraEntregueRange ? "input-emb" : "input-emb-erro"
								}
								style={{ width: "208px" }}
								onChange={(e) => {
									setDataHoraEntregueRange(true);
									setValues((current) => ({
										...current,
										dataHoraEntregue: e.target.value,
									}));
								}}
								value={values.dataHoraEntregue || ""}
							/>
							{!dataHoraEntregueRange && (
								<div className="error-text">Data inválida!</div>
							)}
						</div>
					</div>
				</div>
			</div>

			<CadastroViagemSectionTitle title="Dados do Veículo:" />
			<div className="container-select-emb">
				<div className="embarque-container-placa">
					<div className="coluna-emb">
						<SelectInputField
							label="Placa do Cavalo"
							placeholder="Digite para buscar."
							disabled={false}
							options={veiculoOptions}
							value={valuesSelect.placaCavalo.title || ""}
							onChange={handlePlacaCavaloChange}
							onInputChange={handleVeiculoInputChange}
							onClear={clearPlacaCavalo}
						/>
						<NewIcon
							onClick={() => {
								setOpenCadastroVeiculo(true);
								setIdAtual(null);
								setDisable(false);
							}}
						/>
					</div>
					{mostrarInput && (
						<div className="coluna-emb">
							<div>
								<p className="input-label-emb" htmlFor="descricao">
									Km Vazio:
								</p>
								<input
									type="number"
									className="input-emb"
									style={{ width: "90px" }}
									onChange={(e) => {
										setValues((current) => ({
											...current,
											kmVazio: Number(e.target.value),
										}));
									}}
									value={values.kmVazio || ""}
									disabled={false}
								/>
							</div>
						</div>
					)}
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Proprietário:
							</p>
							<input
								type="text"
								className="input-emb"
								style={{ width: "218px" }}
								onChange={(e) => {
									setValues((current) => ({
										...current,
										proprietario: e.target.value,
									}));
									setValidator((current) => ({
										...current,
										validatorProprietario: "true",
									}));
								}}
								value={values.proprietario || ""}
								disabled={true}
							/>
						</div>
						{props.dadoContato?.[0]?.contato && (
							<div
								style={{
									cursor: "pointer",
									paddingTop: "16px",
									height: "56px",
									color: "#25d366",
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
								}}
							>
								<WhatsAppIcon
									onClick={() => abrirWhats(props.dadoContato[0].contato)}
								/>
							</div>
						)}
					</div>
					<div
						className="coluna-emb"
						style={{
							maxWidth: "170px",
						}}
					>
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Motorista:
							</p>
							{verificaMotorista2 ? (
								<input
									type="text"
									className="input-emb"
									style={{ width: "150px" }}
									onChange={(e) => {
										setValues((current) => ({
											...current,
											motorista: e.target.value,
										}));
									}}
									value={values.motorista || ""}
									disabled={verificaMotorista2}
								/>
							) : (
								<Select
									options={[
										{
											value: listaMotoristas,
											label: listaMotoristas,
											id: idMotoristas,
										},
										{
											value: listaMotoristas2,
											label: listaMotoristas2,
											id: idMotoristas2,
										},
									]}
									styles={estiloFrota}
									value={{
										value: values.motorista,
										label: values.motorista,
									}}
									isDisabled={verificaMotorista2}
									onChange={(selectedOption) => {
										setValues((current) => ({
											...current,
											motorista: selectedOption.value,
										}));
										setValues((current) => ({
											...current,
											motoristaSelecionadoId: selectedOption.id,
										}));
									}}
								/>
							)}
						</div>
						{props.dadoMotorista?.telefone && (
							<div
								style={{
									cursor: "pointer",
									paddingTop: "16px",
									height: "56px",
									color: "#25d366",
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
								}}
							>
								<WhatsAppIcon
									onClick={() => abrirWhats(props.dadoMotorista.telefone)}
								/>
							</div>
						)}
					</div>
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Placa da Carreta:
							</p>
							<input
								type="text"
								className="input-emb"
								style={{ width: "140px" }}
								onChange={(e) => {
									setValues((current) => ({
										...current,
										placaCarreta: e.target.value,
									}));
									setValidator((current) => ({
										...current,
										validatorPlacaCarreta: "true",
									}));
								}}
								value={values.placaCarreta || ""}
								disabled={true}
							/>
						</div>
					</div>
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Placa Segunda Carreta:
							</p>
							<input
								type="text"
								className="input-emb"
								style={{ width: "140px" }}
								onChange={(e) => {
									setValues((current) => ({
										...current,
										placaCarreta2: e.target.value,
									}));
									setValidator((current) => ({
										...current,
										validatorPlacaCarreta2: "true",
									}));
								}}
								value={values.placaCarreta2 || ""}
								disabled={true}
							/>
						</div>
					</div>
				</div>
				<Separator size="md" />
				<IAHelpButton
					disabledTooltip={disabledIaButtonToolTip}
					disabled={disabledIaButton}
					onClick={() => setOpenModalEncontrarVeiculo(true)}
				/>
			</div>

			<CadastroViagemSectionTitle title="Dados Financeiros:" />
			<div className="container-select-emb">
				<div className="coluna-1-emb">
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Adicional Empresa:
							</p>
							<input
								type="text"
								placeholder="0,00"
								className="input-emb"
								style={{ width: "222px" }}
								onChange={(e) => {
									setValues((current) => ({
										...current,
										adicionalEmpresa: e.target.value,
									}));
								}}
								onBlur={(e) => {
									setValues((current) => ({
										...current,
										adicionalEmpresa: normalizeCurrency(
											e.target.value
										),
									}));
								}}
								value={values.adicionalEmpresa}
							/>
						</div>
					</div>
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Adicional Motorista:
							</p>
							<input
								type="text"
								placeholder="0,00"
								className="input-emb"
								style={{ width: "222px" }}
								onChange={(e) => {
									setValues((current) => ({
										...current,
										adicionalMotorista: e.target.value,
									}));
									calcular(e.target.value);
								}}
								onBlur={(e) => {
									setValues((current) => ({
										...current,
										adicionalMotorista: normalizeCurrency(
											e.target.value
										),
									}));
								}}
								value={values.adicionalMotorista}
							/>
						</div>
					</div>
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Adiantamento:
							</p>
							<input
								type="text"
								placeholder="0,00"
								className="input-emb"
								style={{ width: "222px" }}
								onChange={(e) => {
									setValues((current) => ({
										...current,
										adiantamento: e.target.value,
									}));
								}}
								onBlur={(e) => {
									setValues((current) => ({
										...current,
										adiantamento: normalizeCurrency(
											e.target.value
										),
									}));
								}}
								value={values.adiantamento}
							/>
						</div>
					</div>
					<div className={"coluna-emb"}>
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Aceite:
							</p>
							<FormControl sx={{ width: 150 }}>
								<Select
									value={valuesSelect.aceite}
									options={opcoesFrota}
									formatOptionLabel={labelFrota}
									styles={estiloFrota}
									placeholder="Selecione"
									noOptionsMessage={selectMessage}
									onChange={(selectedOption) => {
										if (selectedOption) {
											setValues((current) => ({
												...current,
												aceite: selectedOption.opcao,
											}));
											setValuesSelect((current) => ({
												...current,
												aceite: selectedOption,
											}));
										}
									}}
								/>
							</FormControl>
						</div>
					</div>
					<div className="coluna-emb">
						<div>
							<p className="input-label-emb" htmlFor="descricao">
								Saldo:
							</p>
							<input
								type="text"
								className="input-emb"
								placeholder="0,00"
								style={{ width: "222px" }}
								onChange={(e) => {
									setValues((current) => ({
										...current,
										saldo: e.target.value,
									}));
								}}
								onBlur={(e) => {
									setValues((current) => ({
										...current,
										saldo: normalizeCurrency(e.target.value, "0,00", true),
									}));
								}}
								value={values.saldo}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default memo(FormEmbarqueTop);
